import { makeStyles, createStyles, MuiTheme } from '@kis-technologies/kis-ui';

export const useStyles = makeStyles((theme: MuiTheme) =>
  createStyles({
    outerContainer: {
      minWidth: '100%',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '0px 24px 24px 24px'
    },
    innerContainer: {
      height: '810px',
      minWidth: '100%',
      background: 'white',
      borderRadius: '8px',
      boxShadow: 'rgba(0, 0, 0, 0.2) 0px 3px 9px 0px ',
      padding: '64px 140px 64px 140px',
      [theme.breakpoints.down('lg')]: {
        height: 1640,
        padding: '64px'
      }
    },
    headerContainer: {
      minWidth: '100%',
      margin: '0px 0px 60px 0px',
      [theme.breakpoints.down('lg')]: {
        paddingTop: '35px'
      }
    }
  })
);
